import { TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { Grid, Icon } from '@material-ui/core';
import { ToggleButton } from '@material-ui/lab';
import { American, Elo, MasterCard, Visa } from 'app/assets/cartao';
import SelectConta from 'app/components/Select/SelectConta';
import { useFormikContext } from 'formik';
import React, { useContext } from 'react';
import { ContaContext } from '../../../ContaContext';
import { bandeiras } from './bandeiras';
import { editarCartaoStyles } from './styles';

const onlyNumberRegex = /^\d*$/;

const EditarContaCartaoForm = () => {
  const formik = useFormikContext();

  const [bancos] = useContext(ContaContext).bancos;

  const styles = editarCartaoStyles();

  const setBandeira = (bandeira) => {
    formik.setFieldValue('contaCartao.bandeira', bandeira);
  };

  const handleChangeDia = (event) => {
    if (event.target.value?.length <= 2) {
      formik.handleChange(event);
    }
  };

  const { touched, errors, submitCount } = formik;

  const _errors = {
    descricao: (submitCount || touched.descricao) && errors.descricao,
    contaCartao: {
      digitosCartao: (submitCount || touched.contaCartao?.digitosCartao) && errors.contaCartao?.digitosCartao,
      emissorId: (submitCount || touched.contaCartao?.emissorId) && errors.contaCartao?.emissorId,
      contaPadraoPagamentoId:
        (submitCount || touched.contaCartao?.contaPadraoPagamentoId) && errors.contaCartao?.contaPadraoPagamentoId,
      diaFechamento: (submitCount || touched.contaCartao?.diaFechamento) && errors.contaCartao?.diaFechamento,
      diaVencimento: (submitCount || touched.contaCartao?.diaVencimento) && errors.contaCartao?.diaVencimento,
    },
  };

  return (
    <Grid container spacing={3} className="mt-56">
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          id="descricao"
          name="descricao"
          autoFocus
          error={_errors.descricao}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          touched={formik.touched}
          value={formik.values.descricao}
          required
          fullWidth
          maxLength={30}
          label="Descrição"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <TextInput
          id="contaCartao.digitosCartao"
          name="contaCartao.digitosCartao"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          touched={formik.touched?.contaCartao?.digitosCartao}
          value={formik.values?.contaCartao?.digitosCartao}
          error={_errors.contaCartao.digitosCartao}
          pattern={onlyNumberRegex}
          required
          fullWidth
          maxLength={4}
          label="Últimos 4 dígitos do cartão"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <SelectInput
          label="Emissor do cartão"
          id="contaCartao.emissorId"
          name="contaCartao.emissorId"
          error={_errors.contaCartao.emissorId || ''}
          touched={!!_errors.contaCartao.emissorId}
          helperText={_errors.contaCartao.emissorId || ''}
          required
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.contaCartao?.emissorId}
          options={
            bancos
              ? bancos.map((banco) => ({
                  id: banco.id,
                  title: `${banco.codigo ? `${banco.codigo} - ` : ''}${banco.nome}`,
                }))
              : []
          }
        />
      </Grid>

      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <SelectConta
          id="contaCartao.contaPadraoPagamentoId"
          fullWidth
          label="Conta"
          value={formik.values?.conta}
          onChange={(event) => {
            formik.handleChange(event);
            formik.handleChange({
              target: {
                id: 'formaPagamento',
                value: undefined,
              },
            });
          }}
          onBlur={formik.handleBlur}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <TextInput
          id="contaCartao.diaFechamento"
          name="contaCartao.diaFechamento"
          onChange={handleChangeDia}
          onBlur={formik.handleBlur}
          touched={formik.touched?.contaCartao?.diaFechamento}
          value={formik.values?.contaCartao?.diaFechamento}
          error={_errors.contaCartao.diaFechamento}
          pattern={onlyNumberRegex}
          required
          fullWidth
          maxLength={2}
          label="Dia de fechamento"
        />
      </Grid>

      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <TextInput
          id="contaCartao.diaVencimento"
          name="contaCartao.diaVencimento"
          onChange={handleChangeDia}
          onBlur={formik.handleBlur}
          touched={formik.touched?.contaCartao?.diaVencimento}
          value={formik.values?.contaCartao?.diaVencimento}
          error={_errors.contaCartao.diaVencimento}
          maxLength={2}
          pattern={onlyNumberRegex}
          required
          fullWidth
          label="Dia de vencimento"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <div className=" flex justify-around">
          <ToggleButton
            className={styles.cardButton}
            value="check"
            selected={formik.values?.contaCartao?.bandeira === bandeiras.visa}
            onClick={() => setBandeira(bandeiras.visa)}
          >
            <img src={Visa} alt="Cartão Visa" />
          </ToggleButton>
          <ToggleButton
            className={styles.cardButton}
            value="check"
            selected={formik.values?.contaCartao?.bandeira === bandeiras.mastercard}
            onClick={() => setBandeira(bandeiras.mastercard)}
          >
            <img src={MasterCard} alt="Cartão Mastercard" />
          </ToggleButton>
          <ToggleButton
            className={styles.cardButton}
            value="check"
            selected={formik.values?.contaCartao?.bandeira === bandeiras.americanExpress}
            onClick={() => setBandeira(bandeiras.americanExpress)}
          >
            <img src={American} alt="Cartão American Express" />
          </ToggleButton>
          <ToggleButton
            className={styles.cardButton}
            value="check"
            selected={formik.values?.contaCartao?.bandeira === bandeiras.elo}
            onClick={() => setBandeira(bandeiras.elo)}
          >
            <img src={Elo} alt="Cartão Elo" />
          </ToggleButton>
          <ToggleButton
            className={styles.cardButton}
            value="check"
            selected={formik.values?.contaCartao?.bandeira === bandeiras.outro}
            onClick={() => setBandeira(bandeiras.outro)}
          >
            <Icon color="" fontSize="large">
              credit_card
            </Icon>
          </ToggleButton>
        </div>
      </Grid>
    </Grid>
  );
};

export default EditarContaCartaoForm;
